/**
 * Serialise a value to JSON-LD for embedding in a <script type="application/ld+json"> block.
 *
 * Hand-rolling this with template strings and a partial escaper is how the site ended up shipping
 * unparseable structured data: the previous helpers escaped quotes (and sometimes HTML entities)
 * but never newlines, and both blog excerpts and rendered FAQ answers contain them freely. Any
 * post whose description held a line break emitted "Bad control character in string literal" and
 * earned no rich results at all.
 *
 * JSON.stringify handles all of that. The two extra replacements cover the sequences that are legal
 * inside JSON but would still break out of, or corrupt, the surrounding <script> element:
 *   - `<` is escaped so a `</script>` in the content cannot terminate the block early;
 *   - U+2028 / U+2029 are valid JSON but invalid raw in JavaScript source.
 */
module.exports = function serializeJsonLd(data) {
  return JSON.stringify(data)
    .replace(/</g, '\\u003c')
    .replace(/[\u2028\u2029]/g, (c) => `\\u${c.charCodeAt(0).toString(16)}`);
};
